/**
 * The eight Historic Encounters, as one register.
 *
 * `HISTORIC.DAT`'s own order, which is the order `SELECT HISTORIC MISSION:`
 * lists them in. Ids are `historic-1` … `historic-8`, one-based to match the
 * screen, and each is also a `MISSION_CATALOG` id so that a launch URL
 * (`/fly?m=historic-4&side=german`) round-trips through the same machinery
 * every other mission uses.
 */

import type { Nation } from "./mission-roster.ts";
import { HISTORIC_SCENES_A } from "./historic-scenes-a.ts";
import { HISTORIC_SCENES_B } from "./historic-scenes-b.ts";
import { seatOf, type HistoricEncounterData } from "./historic-scene.ts";

export const HISTORIC_ENCOUNTERS: readonly HistoricEncounterData[] = [...HISTORIC_SCENES_A, ...HISTORIC_SCENES_B];

export const HISTORIC_ENCOUNTER_IDS: readonly string[] = HISTORIC_ENCOUNTERS.map((item) => item.id);

/** The prefix every historic catalog id carries, so a caller can tell one at a glance. */
export const HISTORIC_ID_PREFIX = "historic-";

export function historicEncounter(id: string): HistoricEncounterData | undefined {
  return HISTORIC_ENCOUNTERS.find((item) => item.id === id);
}

export function isHistoricId(id: string): boolean {
  return HISTORIC_ENCOUNTER_IDS.includes(id);
}

/**
 * Whether the file offers this seat at all. Only Immelmann's First Victory
 * refuses one, and the original's own refusal is
 * *"You cannot play the %b side of this mission."*
 */
export function historicSeatPlayable(id: string, nation: Nation): boolean {
  const data = historicEncounter(id);
  return data ? seatOf(data, nation).playable : false;
}

/** `PS.EXE`'s wording for a seat the encounter does not have. `%b` is the side. */
export function historicSeatRefusal(nation: Nation): string {
  return `You cannot play the ${nation === "german" ? "German" : "British"} side of this mission.`;
}
